import { type AppState, type Selector } from '../rootReducer';
import { type DashboardDetailsType } from './types';

export const getDashboardDetails: Selector<DashboardDetailsType> = (state: AppState) =>
  state.dashboard;

export const getIsLoading: Selector<boolean> = (
  state: AppState
) => state.dashboard.loading;
